// Please don't change values of constants since they are used in database

export const SALES_ORDER_OVERVIEW = 'SalesOrderOverview'

export const SALES_ORDER_STATUS_HISTORY = 'StatusHistory'



// WEBPACK FOOTER //
// ./src/modules/sales-order/ui-definition/sales-order-ui.js